import { gql } from "@apollo/client";

const UPDATE_PRICELIST = gql`
    mutation updatePricelist($model: ArticlePricelistInputModel!) {
    companyAdminContext {
      pricelists {
        updatePricelist(model: $model) {
          success
          errorResult {
            data {
              key
              value
            }
            errorMessage
            errorCode
          }
          result {
            articlePriceListId
            companyId
            description
            name
            rows {
              amount
              articlePriceListRowId
              artNo
              price
              productionCost
              shortDescription
              sortIndex
            }
          }
        }
      }
    }
  }
`;

export default UPDATE_PRICELIST;